export default [
  {
    path: 'settings',
    name: 'settings.index',
    meta: {
      title: 'Configurações',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "settings" */ '../views/settings/index.vue')
  },
  {
    path: 'settings/store',
    name: 'settings.store',
    meta: {
      title: 'Configurar sua Loja',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "settings" */ '../views/store/Create.vue')
  },
  {
    path: 'settings/social',
    name: 'settings.social',
    meta: {
      title: 'Redes Sociais',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "settings" */ '../views/settings/sociais.vue')
  }
]
